import { useState } from 'react';
import { motion } from 'framer-motion';
import { aikupData } from '../data/aikupData';
import AikupCard from '../components/AikupCard';
import AikupModal from '../components/AikupModal';
import ExpertVisionModal from '../components/ExpertVisionModal';
import PrimeReferentielModal from '../components/PrimeReferentielModal';
import LivrablesPortfolio from '../components/LivrablesPortfolio';
import FicheEmploiPrime from '../components/FicheEmploiPrime';
import CadreReferentielModal from '../components/CadreReferentielModal';
import GouvernanceComiteModal from '../components/GouvernanceComiteModal';
import ComiteTIReunionsModal from '../components/ComiteTIReunionsModal';
import DiagnosticTIWizard from '../components/DiagnosticTIWizard';
import DiagnosticTIPricingModal from '../components/DiagnosticTIPricingModal';
import MethodologiePRIsMEModal from '../components/MethodologiePRIsMEModal';
import CertificationPRIsMEModal from '../components/CertificationPRIsMEModal';
import CadresNISTModal from '../components/CadresNISTModal';
import AIInsightBubble from '../components/AIInsightBubble';
import Header from '../layout/Header';
import LeadersSection from '../components/LeadersSection';
import LeaderInfoModal from '../components/LeaderInfoModal';
import FormationGestionDocumentaireCard from '../components/FormationGestionDocumentaireCard';
import ArbrePRIsMECard from '../components/ArbrePRIsMECard';
import GestionProjetsPRIsMECard from '../components/GestionProjetsPRIsMECard';
import ProcedureGestionProjetsModal from '../components/ProcedureGestionProjetsModal';
import type { AikupItem } from '../data/aikupData';
import { Shield, FileText, Siren, MessageSquareText, Brain, Clock, Bot } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import AdminModal from '../components/AdminModal';
import PriseDeBesoinWizardModal from '../components/PriseDeBesoinWizardModal';
import CodeRougeModal from '../components/CodeRougeModal';
import ComiteTIPrismeModal from '../components/ComiteTIPrismeModal';
import PrismeLoginLogsModal from '../components/PrismeLoginLogsModal';
import GouvernanceCEModal from '../components/GouvernanceCEModal';
import RegistreClientsPerdusModal from '../components/RegistreClientsPerdusModal';
import ScrumTIModal from '../components/ScrumTIModal';
import PriseEnChargeClientModal from '../components/PriseEnChargeClientModal';
import TechPrimeFollowupsModal from '../components/TechPrimeFollowupsModal';
import SimoneBZBotModal from '../components/SimoneBZBotModal';

// Réunion Direction du service : accès réservé à la direction (5 personnes)
const REUNION_DIRECTION_SERVICE_EMAILS = [
  'jean-michel.caouette@bzinc.ca',
  'vincent.bourassa@bzinc.ca',
  'eric.hains@bzinc.ca',
  'jean-pierre.leclerc@bzinc.ca',
  'dany.bourassa@bzinc.ca',
];

export default function DirectionTI() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [isAdminOpen, setIsAdminOpen] = useState(false);
  const [isCodeRougeOpen, setIsCodeRougeOpen] = useState(false);
  const [isReunionDirectionOpen, setIsReunionDirectionOpen] = useState(false);
  const [isRencontresTechniciensPrimesOpen, setIsRencontresTechniciensPrimesOpen] = useState(false);
  const [isProcedureGestionProjetsOpen, setIsProcedureGestionProjetsOpen] = useState(false);
  const [isPrismeLoginLogsOpen, setIsPrismeLoginLogsOpen] = useState(false);
  const [isGouvernanceCEOpen, setIsGouvernanceCEOpen] = useState(false);
  const [isRegistreClientsPerdusOpen, setIsRegistreClientsPerdusOpen] = useState(false);
  const [isScrumTIOpen, setIsScrumTIOpen] = useState(false);
  const [isPriseEnChargeClientOpen, setIsPriseEnChargeClientOpen] = useState(false);
  const [isTechPrimeFollowupsOpen, setIsTechPrimeFollowupsOpen] = useState(false);
  const [isSimoneOpen, setIsSimoneOpen] = useState(false);

  const [selectedItem, setSelectedItem] = useState<AikupItem | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [expertVisionModal, setExpertVisionModal] = useState<{
    isOpen: boolean;
    expert: 'dany' | 'yannick' | 'francois' | null;
    item: AikupItem | null;
  }>({
    isOpen: false,
    expert: null,
    item: null,
  });
  const [isPrimeModalOpen, setIsPrimeModalOpen] = useState(false);
  const [isLivrablesModalOpen, setIsLivrablesModalOpen] = useState(false);
  const [isFicheEmploiOpen, setIsFicheEmploiOpen] = useState(false);
  const [isCadreReferentielOpen, setIsCadreReferentielOpen] = useState(false);
  const [isGouvernanceComiteOpen, setIsGouvernanceComiteOpen] = useState(false);
  const [isComiteTIReunionsOpen, setIsComiteTIReunionsOpen] = useState(false);
  const [isDiagnosticPricingOpen, setIsDiagnosticPricingOpen] = useState(false);
  const [isDiagnosticTIOpen, setIsDiagnosticTIOpen] = useState(false);
  const [isRapportIncidentPdbOpen, setIsRapportIncidentPdbOpen] = useState(false);
  const [isMethodologieOpen, setIsMethodologieOpen] = useState(false);
  const [isCertificationOpen, setIsCertificationOpen] = useState(false);
  const [isCadresNISTOpen, setIsCadresNISTOpen] = useState(false);
  const [cardLeaderModal, setCardLeaderModal] = useState<{
    isOpen: boolean;
    leader: (typeof leaders)[number] | null;
    cardTitle: string;
    cardId: number | null;
  }>({
    isOpen: false,
    leader: null,
    cardTitle: '',
    cardId: null,
  });

  const handleCardClick = (item: AikupItem) => {
    // Si c'est la carte "Référentiel Prime", ouvrir la modal spécialisée
    if (item.id === 1) {
      setIsPrimeModalOpen(true);
    } else if (item.id === 2) {
      // Si c'est la carte "Communication Client & Livrables Tangibles"
      setIsLivrablesModalOpen(true);
    } else if (item.id === 3) {
      // Si c'est la carte "Gouvernance du Comité TI"
      setIsGouvernanceComiteOpen(true);
    } else if (item.id === 4) {
      // Si c'est la carte "Comité TI - Gestion des Réunions"
      setIsComiteTIReunionsOpen(true);
    } else if (item.id === 6) {
      // Si c'est la carte "Cadre Référentiel BZ"
      setIsCadreReferentielOpen(true);
    } else if (item.id === 14) {
      // Si c'est la carte "Responsabilité & Suivi", ouvrir la fiche d'emploi
      setIsFicheEmploiOpen(true);
    } else if (item.id === 11) {
      // Si c'est la carte "Diagnostic TI", ouvrir la modal pricing/fiche produit
      setIsDiagnosticPricingOpen(true);
    } else if (item.id === 19) {
      // Si c'est la carte "Rapport d'Incident" → ouvrir directement la prise de besoin (template v1)
      setIsRapportIncidentPdbOpen(true);
    } else if (item.id === 13) {
      // Si c'est la carte "Méthodologie PRIsME"
      setIsMethodologieOpen(true);
    } else if (item.id === 20) {
      // Si c'est la carte "Certification PRIsME"
      setIsCertificationOpen(true);
    } else if (item.id === 21) {
      // Si c'est la carte "Cadres NIST - CSF 2.0 & RMF"
      setIsCadresNISTOpen(true);
    } else if (item.id === 22) {
      // Réunion Direction du service (accès réservé aux 5 personnes)
      setIsReunionDirectionOpen(true);
    } else if (item.id === 23) {
      // Rencontres Techniciens Primes
      setIsRencontresTechniciensPrimesOpen(true);
    } else if (item.id === 24) {
      // Procédure de gestion de projet (base de gestion de projet) — liste de taches (représentation statique)
      setIsProcedureGestionProjetsOpen(true);
    } else if (item.id === 29) {
      // Registre des clients perdus — tableau de bord opérationnel
      setIsRegistreClientsPerdusOpen(true);
    } else if (item.id === 26) {
      // Scrum-TI - points à discuter et historique des scrums du lundi
      setIsScrumTIOpen(true);
    } else {
      setSelectedItem(item);
      setIsModalOpen(true);
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setTimeout(() => setSelectedItem(null), 300);
  };

  const handleClosePrimeModal = () => {
    setIsPrimeModalOpen(false);
  };

  const handleCloseLivrablesModal = () => {
    setIsLivrablesModalOpen(false);
  };

  const isAdminUser =
    !!user &&
    [
      'dany.bourassa@bzinc.ca',
      'jean-pierre.leclerc@bzinc.ca',
      'eric.hains@bzinc.ca',
      'francis.marquis@bzinc.ca',
      'jean-michel.caouette@bzinc.ca',
      'stephane.paradis@bzinc.ca',
    ].includes(user.email.toLowerCase());

  const leaders = [
    {
      name: "Jean-Pierre Leclerc",
      title: "Directeur du département",
      avatar: "/JP.png",
      email: "jean-pierre.leclerc@bzinc.ca",
      departmentKey: "direction-ti",
      vision: "Jean-Pierre dirige le département Service & Direction TI avec une vision claire : l'excellence opérationnelle et la satisfaction client. Il voit PRIsME comme l'outil qui structure notre expertise et la rend accessible à tous nos clients.",
      attentes: "Jean-Pierre s'attend à ce que PRIsME facilite la communication avec nos clients, standardise nos livrables, et renforce notre positionnement comme leader en excellence TI. Il veut voir chaque membre de l'équipe utiliser PRIsME pour livrer de la qualité constante.",
      pagePRIsME: "La page PRIsME de Service & Direction TI reflète notre expertise complète : gouvernance TI, livrables tangibles, diagnostic, méthodologie. C'est notre vitrine d'excellence."
    },
    {
      name: "Eric Hains",
      title: "Directeur adjoint - Chargé de projets - Premier implanteur PRIsME client",
      avatar: "/EH.png",
      email: "eric.hains@bzinc.ca",
      departmentKey: "direction-ti",
      vision: "Eric est le premier à avoir implanté un PRIsME client. Il est plus qu'emballé et excité de voir la réaction des clients à chaque présentation. Il voit PRIsME comme un outil révolutionnaire qui transforme notre façon de livrer de la valeur.",
      attentes: "Eric s'attend à ce que chaque présentation PRIsME client génère de l'enthousiasme et de l'engagement. Il veut voir les clients comprendre immédiatement la valeur et l'impact de PRIsME sur leur organisation. Son objectif : que chaque client devienne un ambassadeur PRIsME.",
      pagePRIsME: "La page PRIsME représente pour Eric l'opportunité de montrer aux clients notre méthodologie structurée, nos livrables tangibles, et notre excellence opérationnelle. C'est l'outil qui fait la différence."
    },
    {
      name: "Vincent Bourassa",
      title: "Directeur adjoint - Leader technique et sécurité",
      avatar: "/VB.png",
      email: "vincent.bourassa@bzinc.ca",
      departmentKey: "direction-ti",
      vision: "Vincent est notre leader technique et sécurité. Il est toujours là pour livrer de la qualité technique et aider ses collègues. Il voit PRIsME comme le cadre qui assure la cohérence technique et la qualité dans tous nos livrables.",
      attentes: "Vincent s'attend à ce que PRIsME garantisse la qualité technique de tous nos livrables. Il veut voir chaque projet respecter nos standards techniques et de sécurité. Son objectif : que PRIsME soit la référence pour l'excellence technique BZ.",
      pagePRIsME: "La page PRIsME de Service & Direction TI doit refléter notre excellence technique : diagnostic TI, sécurité, méthodologie, livrables de qualité. C'est notre signature technique."
    },
    {
      name: "Jean-Michel Caouette",
      title: "Directeur adjoint - Opérations - Prime d'exception BZ",
      avatar: "/JMC.png",
      email: "jean-michel.caouette@bzinc.ca",
      departmentKey: "direction-ti",
      vision: "Jean-Michel est un Prime d'exception chez BZ depuis plusieurs années. Son charisme fait de lui un atout incroyable non seulement pour livrer au client mais également pour inspirer l'équipe. Il a la touche de création et une vision d'un livrable tangible parfait pour le client.",
      attentes: "Jean-Michel s'attend à ce que PRIsME permette de créer des livrables tangibles parfaits pour chaque client. Il veut voir chaque livrable refléter notre excellence et notre créativité. Son objectif : que PRIsME soit l'outil qui transforme nos idées en réalité client.",
      pagePRIsME: "La page PRIsME représente pour Jean-Michel l'opportunité de créer des livrables exceptionnels. C'est l'outil qui structure sa créativité et sa vision pour livrer de la valeur tangible à nos clients."
    },
    {
      name: "Francis Marquis",
      title: "Directeur adjoint - Directeur TI",
      avatar: "/FM.png",
      email: "francis.marquis@bzinc.ca",
      departmentKey: "direction-ti",
      vision: "Francis contribue à la direction TI avec une approche structurée, calme et orientée vers l'accompagnement des clients et des équipes. Il voit PRIsME comme un levier pour clarifier les priorités, les responsabilités et la valeur livrée.",
      attentes: "Francis s'attend à ce que PRIsME soutienne une gouvernance TI simple, des suivis rigoureux et des décisions bien documentées. Son objectif est de faciliter la collaboration et d'assurer une expérience client cohérente.",
      pagePRIsME: "La page PRIsME de Service & Direction TI permet à Francis de relier la gouvernance, les opérations, les projets et les suivis clients dans une vision commune et concrète."
    }
  ];

  // Format simplifié pour les cards
  const cardLeaders = leaders.map(l => ({
    name: l.name,
    avatar: l.avatar,
    title: l.title,
    email: l.email,
    departmentKey: l.departmentKey,
  }));

  const priseEnChargeClientCard: AikupItem = {
    id: 10002,
    title: 'Prise en charge client',
    category: 'Opérations',
    description: 'Créer et suivre les prises en charge TI des clients PRIsME avec checklist terrain, technicien Prime, historique et filtres.',
    aiSuggestion: 'Ouvrir le registre de prise en charge client TI pour structurer les démarrages et suivis opérationnels.',
    kpiScore: 94,
    imageUrl: 'https://images.unsplash.com/photo-1497366754035-f200968a6e72?w=1200&auto=format&fit=crop&q=80',
    isCompleted: true,
    inKnowledgeBase: false,
  };

  const techPrimeFollowupsCard: AikupItem = {
    id: 10003,
    title: 'Suivis clients Tech Prime',
    category: 'Opérations',
    description: 'Gérer les suivis clients issus de la liste Prime: projets, comité TI, prochain contact, actions BZ et courriels de suivi.',
    aiSuggestion: 'Ouvrir les suivis clients Tech Prime pour préparer les prochains contacts, actions BZ et courriels.',
    kpiScore: 94,
    imageUrl: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=1200&auto=format&fit=crop&q=80',
    isCompleted: true,
    inKnowledgeBase: false,
  };

  const lacEpauleDecembre2026Card: AikupItem = {
    id: 10004,
    title: "Lac à l'épaule décembre 2026",
    category: 'Gouvernance et Conformité',
    description: 'Sous-menu de préparation regroupant les cartes qui seront créées par chaque responsable de sujet.',
    aiSuggestion: 'Accéder à l’espace de préparation du Lac à l’épaule TI de décembre 2026.',
    kpiScore: 100,
    imageUrl: 'https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?w=1200&auto=format&fit=crop&q=80',
    isCompleted: true,
    inKnowledgeBase: false,
  };

  // Filtrer les items pour cette page (id 22 = Réunion Direction du service : visible seulement pour les 5 emails autorisés)
  const canAccessReunionDirection = !!user?.email && REUNION_DIRECTION_SERVICE_EMAILS.includes(user.email.toLowerCase());
  const filteredItems = aikupData.filter(
    item =>
      item.id !== 5 &&
      item.id !== 10 &&
      item.id !== 17 &&
      item.id !== 7 &&
      item.id !== 8 &&
      item.id !== 16 &&
      item.id !== 9 &&
      (item.id !== 22 || canAccessReunionDirection)
  );

  // Organiser par catégorie
  const categories = Array.from(new Set(filteredItems.map(item => item.category)));

  return (
    <div className="min-h-screen bg-linear-to-br from-gray-50 to-gray-100">
      <Header 
        title="Service & Direction TI" 
        subtitle="Les piliers de développement TI & Solutions d'affaires pour une excellence durable"
      />
      
      <div className="max-w-7xl mx-auto px-8 pb-12">
        <LeadersSection leaders={leaders} title="Nos Leaders - Service & Direction TI" />
        
        {/* Stats Overview */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="bg-white rounded-xl shadow-md p-6 border-l-4 border-blue-500"
          >
            <p className="text-sm text-gray-600 mb-1">Outils Disponibles</p>
            <p className="text-3xl font-bold text-gray-900">{filteredItems.length}</p>
            <p className="text-xs text-gray-500 mt-1">Frameworks pratiques</p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="bg-white rounded-xl shadow-md p-6 border-l-4 border-green-500"
          >
            <p className="text-sm text-gray-600 mb-1">Score Maturité</p>
            <p className="text-3xl font-bold text-gray-900">
              {Math.round(filteredItems.reduce((sum, item) => sum + (item.kpiScore || 0), 0) / filteredItems.length)}%
            </p>
            <p className="text-xs text-gray-500 mt-1">Moyenne excellence</p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="bg-white rounded-xl shadow-md p-6 border-l-4 border-purple-500"
          >
            <p className="text-sm text-gray-600 mb-1">Catégories</p>
            <p className="text-3xl font-bold text-gray-900">{categories.length}</p>
            <p className="text-xs text-gray-500 mt-1">Domaines couverts</p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
            className="bg-white rounded-xl shadow-md p-6 border-l-4 border-orange-500"
          >
            <p className="text-sm text-gray-600 mb-1">Excellence TI</p>
            <p className="text-3xl font-bold text-gray-900">
              {filteredItems.filter(item => item.category === 'Excellence' || item.category === 'Framework').length}
            </p>
            <p className="text-xs text-gray-500 mt-1">Outils stratégiques</p>
          </motion.div>
        </div>

        {/* Cards par catégorie */}
        {categories.map((category, categoryIndex) => {
          const itemsInCategory = filteredItems.filter(item => item.category === category);
          
          return (
            <div key={category} className="mb-12">
              <motion.div
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: categoryIndex * 0.1 }}
                className="flex items-center gap-3 mb-6"
              >
                <div className="flex-1 h-px bg-linear-to-r from-blue-500 to-purple-500"></div>
                <h2 className="text-2xl font-bold text-gray-800 px-4">{category}</h2>
                <div className="flex-1 h-px bg-linear-to-l from-blue-500 to-purple-500"></div>
              </motion.div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {/* Première carte visible : accès au sous-menu du Lac à l'épaule */}
                {category === "Gouvernance et Conformité" && (
                  <motion.div
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ delay: categoryIndex * 0.1 }}
                  >
                    <AikupCard
                      item={lacEpauleDecembre2026Card}
                      onClick={() => navigate('/direction-ti/lac-a-epaule-decembre-2026')}
                      onExpertClick={() => undefined}
                      index={0}
                      customLeaders={cardLeaders}
                      onLeaderClick={(leader) => {
                        const selectedLeader = leaders.find(l => l.name === leader.name);
                        if (selectedLeader) {
                          setCardLeaderModal({
                            isOpen: true,
                            leader: selectedLeader,
                            cardTitle: lacEpauleDecembre2026Card.title,
                            cardId: lacEpauleDecembre2026Card.id,
                          });
                        }
                      }}
                    />
                  </motion.div>
                )}

                {itemsInCategory.map((item, idx) => (
                  <motion.div
                    key={item.id}
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ delay: categoryIndex * 0.1 + idx * 0.05 }}
                  >
                    <AikupCard
                      item={item}
                      onClick={() => handleCardClick(item)}
                      onExpertClick={(expert: 'dany' | 'yannick' | 'francois') => {
                        setExpertVisionModal({
                          isOpen: true,
                          expert,
                          item,
                        });
                      }}
                      index={category === "Gouvernance et Conformité" ? idx + 1 : idx}
                      customLeaders={cardLeaders}
                      onLeaderClick={(leader) => {
                        const selectedLeader = leaders.find(l => l.name === leader.name);
                        if (selectedLeader) {
                          setCardLeaderModal({
                            isOpen: true,
                            leader: selectedLeader,
                            cardTitle: item.title,
                            cardId: item.id,
                          });
                        }
                      }}
                    />
                  </motion.div>
                ))}
                
                {/* Ajouter les 3 cards spéciales dans "Excellence et Compétences" */}
                {category === "Excellence et Compétences" && (
                  <>
                    <motion.div
                      initial={{ opacity: 0, scale: 0.9 }}
                      animate={{ opacity: 1, scale: 1 }}
                      transition={{ delay: categoryIndex * 0.1 + itemsInCategory.length * 0.05 }}
                    >
                      <AikupCard
                        item={{
                          id: 10001,
                          title: 'Gouvernance CE',
                          category: '',
                          description: 'Cadre de gouvernance exécutive du CE : axes, maturité, RACI, roadmap et rituels.',
                          aiSuggestion: 'Afficher la structure de gouvernance CE pour aligner la direction TI avec la gouvernance exécutive.',
                          kpiScore: 96,
                          imageUrl: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=1200&auto=format&fit=crop&q=80',
                        }}
                        onClick={() => setIsGouvernanceCEOpen(true)}
                        onExpertClick={(expert: 'dany' | 'yannick' | 'francois') => {
                          setExpertVisionModal({
                            isOpen: true,
                            expert,
                            item: {
                              id: 10001,
                              title: 'Gouvernance CE',
                              category: '',
                              description: 'Cadre de gouvernance exécutive du CE : axes, maturité, RACI, roadmap et rituels.',
                              aiSuggestion: 'Afficher la structure de gouvernance CE pour aligner la direction TI avec la gouvernance exécutive.',
                              kpiScore: 96,
                              imageUrl: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=1200&auto=format&fit=crop&q=80',
                            },
                          });
                        }}
                        index={itemsInCategory.length}
                        customLeaders={cardLeaders}
                        onLeaderClick={(leader) => {
                          const selectedLeader = leaders.find(l => l.name === leader.name);
                          if (selectedLeader) {
                            setCardLeaderModal({
                              isOpen: true,
                              leader: selectedLeader,
                              cardTitle: 'Gouvernance CE',
                              cardId: 10001,
                            });
                          }
                        }}
                      />
                    </motion.div>
                    <motion.div
                      initial={{ opacity: 0, scale: 0.9 }}
                      animate={{ opacity: 1, scale: 1 }}
                      transition={{ delay: categoryIndex * 0.1 + (itemsInCategory.length + 1) * 0.05 }}
                    >
                      <FormationGestionDocumentaireCard
                        department="Service & Direction TI"
                        domain="TI"
                        index={itemsInCategory.length + 1}
                      />
                    </motion.div>
                    <motion.div
                      initial={{ opacity: 0, scale: 0.9 }}
                      animate={{ opacity: 1, scale: 1 }}
                      transition={{ delay: categoryIndex * 0.1 + (itemsInCategory.length + 1) * 0.05 }}
                    >
                      <ArbrePRIsMECard
                        index={itemsInCategory.length + 1}
                      />
                    </motion.div>
                    <motion.div
                      initial={{ opacity: 0, scale: 0.9 }}
                      animate={{ opacity: 1, scale: 1 }}
                      transition={{ delay: categoryIndex * 0.1 + (itemsInCategory.length + 2) * 0.05 }}
                    >
                      <GestionProjetsPRIsMECard
                        department="Service & Direction TI"
                        domain="TI"
                        index={itemsInCategory.length + 2}
                      />
                    </motion.div>
                    <motion.div
                      initial={{ opacity: 0, scale: 0.9 }}
                      animate={{ opacity: 1, scale: 1 }}
                      transition={{ delay: categoryIndex * 0.1 + (itemsInCategory.length + 3) * 0.05 }}
                    >
                      <button
                        type="button"
                        onClick={() => setIsSimoneOpen(true)}
                        className="relative h-64 w-full cursor-pointer overflow-hidden rounded-3xl border border-cyan-200 shadow-md transition-all duration-300 hover:shadow-xl group"
                      >
                        <div
                          className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-110"
                          style={{
                            backgroundImage:
                              'url(https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=1200&auto=format&fit=crop&q=80)',
                          }}
                        />
                        <div className="absolute inset-0 bg-linear-to-t from-slate-950/95 via-blue-950/75 to-cyan-900/35 transition-all duration-300 group-hover:from-blue-950/95" />
                        <div className="relative flex h-full flex-col justify-end p-6 text-white">
                          <motion.div
                            initial={{ scale: 0 }}
                            animate={{ scale: 1 }}
                            transition={{ delay: 0.3, type: 'spring', stiffness: 200 }}
                            className="absolute left-3 top-3 z-10 flex items-center gap-1.5 rounded-full border border-cyan-300/60 bg-cyan-500/30 px-3 py-1.5 shadow-lg shadow-cyan-500/20 backdrop-blur-sm"
                            title="Démo OpenAI branchée"
                          >
                            <Brain className="h-4 w-4 text-cyan-100" />
                            <span className="text-xs font-semibold text-cyan-50">OpenAI</span>
                          </motion.div>
                          <div className="mb-2 flex items-center gap-3">
                            <div className="flex h-10 w-10 items-center justify-center rounded-2xl bg-white/15 shadow-inner">
                              <Bot className="h-5 w-5 text-white" />
                            </div>
                            <h3 className="text-lg font-extrabold drop-shadow">SIMONE — Bot public BZ Inc.</h3>
                          </div>
                          <p className="mb-1 text-xs leading-relaxed text-white/90 drop-shadow">
                            Concept fonctionnel du futur chatbot bzinc.ca: ventes, support, urgence, PRIsME, RAG Markdown et routage intelligent.
                          </p>
                          <span className="mt-1 inline-flex items-center gap-2 text-[11px] font-semibold text-cyan-100">
                            Ouvrir la démo Simone
                            <span className="flex h-4 w-4 items-center justify-center rounded-full bg-white/20 text-[10px] transition-transform group-hover:translate-x-0.5">
                              →
                            </span>
                          </span>
                        </div>
                      </button>
                    </motion.div>
                    <motion.div
                      initial={{ opacity: 0, scale: 0.9 }}
                      animate={{ opacity: 1, scale: 1 }}
                      transition={{ delay: categoryIndex * 0.1 + (itemsInCategory.length + 2) * 0.05 }}
                    >
                      <button
                        onClick={() => navigate('/gestion-documentaire')}
                        className="relative overflow-hidden rounded-3xl shadow-md hover:shadow-xl transition-all duration-300 cursor-pointer h-64 group border border-blue-200 w-full"
                      >
                        {/* Image de fond */}
                        <div
                          className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-110"
                          style={{
                            backgroundImage:
                              'url(https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?w=1200&auto=format&fit=crop&q=80)',
                          }}
                        />

                        {/* Overlay gradient pour lisibilité */}
                        <div className="absolute inset-0 bg-linear-to-t from-black/85 via-black/55 to-black/20 group-hover:from-bz-dark/95 group-hover:via-bz-blue/80 transition-all duration-300" />

                        {/* Contenu */}
                        <div className="relative h-full p-6 flex flex-col justify-end text-white">
                          <div className="flex items-center gap-3 mb-2">
                            <div className="w-10 h-10 rounded-2xl bg-white/15 flex items-center justify-center shadow-inner">
                              <FileText className="w-5 h-5 text-white" />
                            </div>
                            <h3 className="text-lg font-bold drop-shadow">Gestion Documentaire PRIsME</h3>
                          </div>
                          <p className="text-xs text-white/90 leading-relaxed drop-shadow mb-1">
                            Fabrique de documents normés (Plan Directeur, ODS, plans TI) générés et structurés avec PRIsME + IA,
                            puis validés par l&apos;équipe Service &amp; Direction TI.
                          </p>
                          <span className="inline-flex items-center gap-2 text-[11px] font-semibold text-blue-100 mt-1">
                            Entrer dans la fabrique de documents
                            <span className="w-4 h-4 rounded-full bg-white/20 flex items-center justify-center text-[10px] group-hover:translate-x-0.5 transition-transform">
                              →
                            </span>
                          </span>
                        </div>
                      </button>
                    </motion.div>

                    <motion.div
                      initial={{ opacity: 0, scale: 0.9 }}
                      animate={{ opacity: 1, scale: 1 }}
                      transition={{ delay: categoryIndex * 0.1 + (itemsInCategory.length + 4) * 0.05 }}
                    >
                      <button
                        onClick={() => setIsCodeRougeOpen(true)}
                        className="relative overflow-hidden rounded-3xl shadow-md hover:shadow-xl transition-all duration-300 cursor-pointer h-64 group border border-red-300/60 w-full"
                      >
                        <div
                          className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-110"
                          style={{
                            backgroundImage:
                              'url(https://images.unsplash.com/photo-1517281862878-d312fe477d71?w=1200&auto=format&fit=crop&q=80)',
                          }}
                        />

                        <div className="absolute inset-0 bg-linear-to-t from-black/90 via-black/60 to-black/25 group-hover:from-red-900/95 group-hover:via-rose-900/75 transition-all duration-300" />

                        <div className="relative h-full p-6 flex flex-col justify-end text-white">
                          {/* Badge AI - Disponible dans AI Assistant */}
                          <motion.div
                            initial={{ scale: 0 }}
                            animate={{ scale: 1 }}
                            transition={{ delay: 0.3, type: "spring", stiffness: 200 }}
                            className="absolute top-3 left-3 z-10 flex items-center gap-1.5 px-3 py-1.5 backdrop-blur-sm bg-purple-500/40 border border-purple-400/60 rounded-full shadow-lg shadow-purple-500/20"
                            title="Disponible dans AI Assistant"
                          >
                            <Brain className="w-4 h-4 text-purple-200" />
                            <span className="text-xs text-purple-100 font-semibold">AI</span>
                          </motion.div>
                          <div className="flex items-center gap-3 mb-2">
                            <div className="w-10 h-10 rounded-2xl bg-white/15 flex items-center justify-center shadow-inner">
                              <Siren className="w-5 h-5 text-white" />
                            </div>
                            <h3 className="text-lg font-extrabold drop-shadow">CODE ROUGE</h3>
                          </div>
                          <p className="text-xs text-white/90 leading-relaxed drop-shadow mb-1">
                            Activation crise cloud: front uni (comms + PM + tech) avec double piste <strong>troubleshoot</strong> +{' '}
                            <strong>restauration</strong>. Inclut prise en charge BZ Telecom au besoin.
                          </p>
                          <span className="inline-flex items-center gap-2 text-[11px] font-semibold text-red-100 mt-1">
                            Ouvrir le playbook CODE ROUGE
                            <span className="w-4 h-4 rounded-full bg-white/20 flex items-center justify-center text-[10px] group-hover:translate-x-0.5 transition-transform">
                              →
                            </span>
                          </span>
                        </div>
                      </button>
                    </motion.div>
                  </>
                )}

                {/* Tuile spéciale - Logs de connexion (Culture et RH) */}
                {category === "Culture et RH" && isAdminUser && (
                  <motion.div
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ delay: categoryIndex * 0.1 + (itemsInCategory.length + 1) * 0.05 }}
                  >
                    <button
                      type="button"
                      onClick={() => setIsPrismeLoginLogsOpen(true)}
                      className="relative overflow-hidden rounded-3xl shadow-md hover:shadow-xl transition-all duration-300 cursor-pointer h-64 group border border-slate-200 w-full bg-white"
                    >
                      <div className="absolute inset-0 bg-linear-to-br from-slate-50 via-white to-indigo-50 group-hover:from-slate-100 group-hover:to-indigo-100 transition-colors" />
                      <div className="relative h-full p-6 flex flex-col justify-between text-slate-900">
                        <div>
                          <div className="flex items-center gap-3 mb-2">
                            <div className="w-10 h-10 rounded-2xl bg-slate-900/10 flex items-center justify-center shadow-inner">
                              <Clock className="w-5 h-5 text-slate-900" />
                            </div>
                            <h3 className="text-lg font-extrabold">Logs de connexion PRIsME</h3>
                          </div>
                          <p className="text-xs text-slate-700 leading-relaxed">
                            Tableau des connexions (date/heure) pour <strong>PRIsME BZ</strong> et <strong>PRIsME Employés</strong>, séparés.
                          </p>
                        </div>
                        <span className="inline-flex items-center gap-2 text-[11px] font-semibold text-slate-800">
                          Ouvrir les logs
                          <span className="w-5 h-5 rounded-full bg-slate-900 text-white flex items-center justify-center text-[10px] group-hover:translate-x-0.5 transition-transform">
                            →
                          </span>
                        </span>
                      </div>
                    </button>
                  </motion.div>
                )}

                {/* Tuile spéciale - Prise en charge client TI (Opérations) */}
                {category === "Opérations" && (
                  <motion.div
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ delay: categoryIndex * 0.1 + (itemsInCategory.length + 1) * 0.05 }}
                  >
                    <AikupCard
                      item={priseEnChargeClientCard}
                      onClick={() => setIsPriseEnChargeClientOpen(true)}
                      onExpertClick={(expert: 'dany' | 'yannick' | 'francois') => {
                        setExpertVisionModal({
                          isOpen: true,
                          expert,
                          item: priseEnChargeClientCard,
                        });
                      }}
                      index={itemsInCategory.length + 1}
                      customLeaders={cardLeaders}
                      onLeaderClick={(leader) => {
                        const selectedLeader = leaders.find(l => l.name === leader.name);
                        if (selectedLeader) {
                          setCardLeaderModal({
                            isOpen: true,
                            leader: selectedLeader,
                            cardTitle: priseEnChargeClientCard.title,
                            cardId: priseEnChargeClientCard.id,
                          });
                        }
                      }}
                    />
                  </motion.div>
                )}

                {/* Tuile spéciale - Suivis clients Techs Primes (Opérations) */}
                {category === "Opérations" && (
                  <motion.div
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ delay: categoryIndex * 0.1 + (itemsInCategory.length + 2) * 0.05 }}
                  >
                    <AikupCard
                      item={techPrimeFollowupsCard}
                      onClick={() => setIsTechPrimeFollowupsOpen(true)}
                      onExpertClick={(expert: 'dany' | 'yannick' | 'francois') => {
                        setExpertVisionModal({
                          isOpen: true,
                          expert,
                          item: techPrimeFollowupsCard,
                        });
                      }}
                      index={itemsInCategory.length + 2}
                      customLeaders={cardLeaders}
                      onLeaderClick={(leader) => {
                        const selectedLeader = leaders.find(l => l.name === leader.name);
                        if (selectedLeader) {
                          setCardLeaderModal({
                            isOpen: true,
                            leader: selectedLeader,
                            cardTitle: techPrimeFollowupsCard.title,
                            cardId: techPrimeFollowupsCard.id,
                          });
                        }
                      }}
                    />
                  </motion.div>
                )}
              </div>
            </div>
          );
        })}


        {isAdminUser && (
          <div className="mb-12">
            <div className="space-y-4">
              <button
                onClick={() => setIsAdminOpen(true)}
                className="group relative flex flex-col items-start justify-between rounded-3xl border border-blue-200 bg-linear-to-br from-blue-50 via-white to-indigo-50 p-6 shadow-sm hover:shadow-md transition-all hover:-translate-y-0.5 w-full"
              >
                <div className="flex items-center justify-between w-full mb-4">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-2xl bg-blue-600/10 flex items-center justify-center text-blue-600 shadow-inner">
                      <Shield className="w-5 h-5" />
                    </div>
                    <div>
                      <h3 className="font-display text-lg text-blue-900">Administration PRIsME BZ</h3>
                      <p className="text-xs text-blue-700 font-medium">Clients, parties prenantes & accès (BZ Inc. seulement)</p>
                    </div>
                  </div>
                </div>
                <p className="text-sm text-gray-700 mb-3">
                  Tableau de bord interne pour gérer les clients PRIsME, les parties prenantes et les accès utilisateurs (is_user). Réservé aux
                  leaders BZ clés.
                </p>
                <span className="inline-flex items-center gap-2 text-xs font-semibold text-blue-700 mt-auto">
                  Ouvrir l'espace Administration
                  <span className="w-5 h-5 rounded-full bg-blue-600 text-white flex items-center justify-center text-[10px] group-hover:translate-x-0.5 transition-transform">
                    →
                  </span>
                </span>
              </button>

              <button
                onClick={() => navigate('/direction-ti/commentaires')}
                className="group relative flex flex-col items-start justify-between rounded-3xl border border-slate-200 bg-linear-to-br from-slate-50 via-white to-slate-100 p-6 shadow-sm hover:shadow-md transition-all hover:-translate-y-0.5 w-full"
              >
                <div className="flex items-center justify-between w-full mb-4">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-2xl bg-slate-900/10 flex items-center justify-center text-slate-900 shadow-inner">
                      <MessageSquareText className="w-5 h-5" />
                    </div>
                    <div>
                      <h3 className="font-display text-lg text-slate-900">Commentaires / Amélioration continue</h3>
                      <p className="text-xs text-slate-700 font-medium">Portrait global (département + cartes)</p>
                    </div>
                  </div>
                </div>
                <p className="text-sm text-gray-700 mb-3">
                  Vue consolidée de tous les commentaires, regroupée par cartes, avec filtres (type, priorité, portée) pour piloter le backlog
                  d’amélioration continue.
                </p>
                <span className="inline-flex items-center gap-2 text-xs font-semibold text-slate-800 mt-auto">
                  Ouvrir le tableau global
                  <span className="w-5 h-5 rounded-full bg-slate-900 text-white flex items-center justify-center text-[10px] group-hover:translate-x-0.5 transition-transform">
                    →
                  </span>
                </span>
              </button>
            </div>
          </div>
        )}
      </div>

      <AikupModal
        item={selectedItem}
        isOpen={isModalOpen}
        onClose={handleCloseModal}
      />

      <PrimeReferentielModal
        isOpen={isPrimeModalOpen}
        onClose={handleClosePrimeModal}
      />

      <LivrablesPortfolio
        isOpen={isLivrablesModalOpen}
        onClose={handleCloseLivrablesModal}
      />

      <FicheEmploiPrime
        isOpen={isFicheEmploiOpen}
        onClose={() => setIsFicheEmploiOpen(false)}
      />

      <CadreReferentielModal
        isOpen={isCadreReferentielOpen}
        onClose={() => setIsCadreReferentielOpen(false)}
      />

      <GouvernanceComiteModal
        isOpen={isGouvernanceComiteOpen}
        onClose={() => setIsGouvernanceComiteOpen(false)}
      />

      <ComiteTIReunionsModal
        isOpen={isComiteTIReunionsOpen}
        onClose={() => setIsComiteTIReunionsOpen(false)}
      />

      <ComiteTIPrismeModal
        isOpen={isReunionDirectionOpen}
        onClose={() => setIsReunionDirectionOpen(false)}
        title="Réunion Direction du service"
        scope="REUNION_DIRECTION_SERVICE"
      />

      <ComiteTIPrismeModal
        isOpen={isRencontresTechniciensPrimesOpen}
        onClose={() => setIsRencontresTechniciensPrimesOpen(false)}
        title="Rencontres Techniciens Primes"
        scope="TECH_PRIMES"
      />

      <ProcedureGestionProjetsModal
        isOpen={isProcedureGestionProjetsOpen}
        onClose={() => setIsProcedureGestionProjetsOpen(false)}
      />

      <DiagnosticTIPricingModal
        isOpen={isDiagnosticPricingOpen}
        onClose={() => setIsDiagnosticPricingOpen(false)}
        onStartQuestionnaire={() => {
          setIsDiagnosticPricingOpen(false);
          setIsDiagnosticTIOpen(true);
        }}
      />

      <DiagnosticTIWizard
        isOpen={isDiagnosticTIOpen}
        onClose={() => setIsDiagnosticTIOpen(false)}
      />

      <PriseDeBesoinWizardModal
        isOpen={isRapportIncidentPdbOpen}
        onClose={() => setIsRapportIncidentPdbOpen(false)}
        templateId="rapport-incident-v1"
        templateVersion="1.0.0"
      />

      <MethodologiePRIsMEModal
        isOpen={isMethodologieOpen}
        onClose={() => setIsMethodologieOpen(false)}
      />

      <CertificationPRIsMEModal
        isOpen={isCertificationOpen}
        onClose={() => setIsCertificationOpen(false)}
      />

      <CadresNISTModal
        isOpen={isCadresNISTOpen}
        onClose={() => setIsCadresNISTOpen(false)}
      />

      <AdminModal
        isOpen={isAdminOpen}
        onClose={() => setIsAdminOpen(false)}
      />
      <CodeRougeModal isOpen={isCodeRougeOpen} onClose={() => setIsCodeRougeOpen(false)} />
      <PrismeLoginLogsModal isOpen={isPrismeLoginLogsOpen} onClose={() => setIsPrismeLoginLogsOpen(false)} />
      <GouvernanceCEModal isOpen={isGouvernanceCEOpen} onClose={() => setIsGouvernanceCEOpen(false)} />
      <RegistreClientsPerdusModal isOpen={isRegistreClientsPerdusOpen} onClose={() => setIsRegistreClientsPerdusOpen(false)} />
      <ScrumTIModal isOpen={isScrumTIOpen} onClose={() => setIsScrumTIOpen(false)} />
      <PriseEnChargeClientModal
        isOpen={isPriseEnChargeClientOpen}
        onClose={() => setIsPriseEnChargeClientOpen(false)}
      />
      <TechPrimeFollowupsModal
        isOpen={isTechPrimeFollowupsOpen}
        onClose={() => setIsTechPrimeFollowupsOpen(false)}
      />
      <SimoneBZBotModal isOpen={isSimoneOpen} onClose={() => setIsSimoneOpen(false)} />

      <ExpertVisionModal
        isOpen={expertVisionModal.isOpen}
        onClose={() => setExpertVisionModal({ isOpen: false, expert: null, item: null })}
        expert={expertVisionModal.expert}
        item={expertVisionModal.item}
        departmentKey="direction-ti"
      />

      <AIInsightBubble />
      {cardLeaderModal.leader && (
        <LeaderInfoModal
          isOpen={cardLeaderModal.isOpen}
          onClose={() =>
            setCardLeaderModal({
              isOpen: false,
              leader: null,
              cardTitle: '',
              cardId: null,
            })
          }
          leader={cardLeaderModal.leader}
          feedbackContextLevel="CARD"
          feedbackCardId={cardLeaderModal.cardId}
          feedbackContextLabel={`Carte: ${cardLeaderModal.cardTitle} – ${cardLeaderModal.leader.name}`}
        />
      )}
    </div>
  );
}
